import { render } from "./AppConfig.vue?vue&type=template&id=54149b5e&scoped=true"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"

import "./AppConfig.vue?vue&type=style&index=0&id=54149b5e&scoped=true&lang=css"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/cdas-intranet-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54149b5e"]])

export default __exports__